module.exports = __webpack_public_path__ + "static/media/loading-monkey.84318d92.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/loading-monkey.svg
// module id = 1315
// module chunks = 389